// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const CourierInfo = t.struct({
    comments: t.String,
    courierAccountNumber: t.String,
    courierName: t.String,
    deereCourier: t.String,
    returnTrackingNumber: t.String
}, {
    name: 'CourierInfo',
    strict: true
});

export const getDefaultState = () => new CourierInfo({
    comments: '',
    courierAccountNumber: '',
    courierName: '',
    deereCourier: '',
    returnTrackingNumber: ''
});

export default CourierInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/courier-info.js